export default __webpack_public_path__ + "static/media/2.2530fe39.jpg";